// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__3Im2n","normal":"Index_normal__-yFmp","normalH5":"Index_normalH5__2sjHE","animationFade":"Index_animationFade__1jj0D"};